module.exports = __webpack_public_path__ + "img/user.e4dc5062.png";